// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.0002 12C23.0002 18.0751 18.0754 23 12.0002 23C5.92511 23 1.00024 18.0751 1.00024 12C1.00024 5.92487 5.92511 1 12.0002 1C18.0754 1 23.0002 5.92487 23.0002 12ZM16.0002 12L12.0002 5.75L8.00024 12L11.0002 12V18H13.0002V12H16.0002Z"}}]};

const ArrowUpCircleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-up-circle-filled',
    ref,
    icon: element,
  },
));

ArrowUpCircleFilledIcon.displayName = 'ArrowUpCircleFilledIcon';

export default ArrowUpCircleFilledIcon;
